import React from 'react';
import { createStore, applyMiddleware } from 'redux';
import ReduxPromise from './ReduxPromise';
import ReduxThunk from 'redux-thunk';
import { typeOfAppList } from './common/constants/page-types';

var store = null;

export default class GlobalStore {

    static createReduxStore(type) {
        const createStoreWithMiddleware = applyMiddleware(ReduxThunk, ReduxPromise)(createStore);
        const reducer = typeOfAppList[type].reducer;
        const store = createStoreWithMiddleware(reducer);

        return store;
    }

    static getStore(type) {
        if (store === null) {
            store = this.createReduxStore(type);
        }

        return store;
    }
}

